// extracted by mini-css-extract-plugin
export default {"FormSectionTitle":"FormSectionTitle_FormSectionTitle__rief8","title_icon":"FormSectionTitle_title_icon__cK1sV"};